var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { put, call, all } from 'redux-saga/effects';
import { requestExtraDataHandlerActionSaga } from '../../request-extra-data-handler-module';
import { redirectManagerSagaAction, } from '../../redirect-manager-module';
import { requestErrorHandlerProcess } from '../../../utils/request-error-handler-process';
import { filterBatchedResponseData } from '../../../utils/filter-batch-response-data';
import { getIsClient } from '../../../utils/get-is-client';
import { checkIsInitialFetched } from './utils/check-is-initial-fetched';
import { getIsAbortRequestError } from './utils/get-is-abort-request-error';
export function spawnedFetchProcessSaga(_a) {
    var responseData, isNode, isInitialFetched, formattedRequestParams_1, formattedResponseData, filteredResponseData_1, redirectData, error_1, isAbortError, event_1, customModalTitle, params, redirectData;
    var resetAction = _a.resetAction, resetActionsArray = _a.resetActionsArray, request = _a.request, requestOptions = _a.requestOptions, requestDataFormatter = _a.requestDataFormatter, responseDataFormatter = _a.responseDataFormatter, actionSuccess = _a.actionSuccess, actionsArraySuccess = _a.actionsArraySuccess, requestExtraDataHandlerOptions = _a.requestExtraDataHandlerOptions, showSuccessNotification = _a.showSuccessNotification, isDataCritical = _a.isDataCritical, errorAction = _a.errorAction, errorActionsArray = _a.errorActionsArray, showErrorNotification = _a.showErrorNotification, loadingStopAction = _a.loadingStopAction, loadingStartAction = _a.loadingStartAction, withoutFormattingError = _a.withoutFormattingError, formatDataToRedirectParamsSuccess = _a.formatDataToRedirectParamsSuccess, redirectRouteParamsSuccess = _a.redirectRouteParamsSuccess, formatDataToRedirectParamsError = _a.formatDataToRedirectParamsError, redirectRouteParamsError = _a.redirectRouteParamsError, textMessageSuccess = _a.textMessageSuccess, titleMessageSuccess = _a.titleMessageSuccess, setAppErrorAction = _a.setAppErrorAction, requestsSectionId = _a.requestsSectionId, eventNameToCancelRequests = _a.eventNameToCancelRequests, eventToCatchEndedProcesses = _a.eventToCatchEndedProcesses, requestErrorHandlerProcessParams = _a.requestErrorHandlerProcessParams, isBatchRequest = _a.isBatchRequest, getErrorModalActionTitle = _a.getErrorModalActionTitle, initialLoadingFinishAction = _a.initialLoadingFinishAction, selectorsCheckInitialFetched = _a.selectorsCheckInitialFetched, store = _a.store, callBackOnSuccess = _a.callBackOnSuccess, callBackOnError = _a.callBackOnError, dispatch = _a.dispatch, disableErrorLogger = _a.disableErrorLogger, titleMessageError = _a.titleMessageError, errorLogger = _a.errorLogger, counterRequests = _a.counterRequests, setModalAction = _a.setModalAction;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                isNode = !getIsClient();
                // not to refetch if data was fetched earlier
                if (selectorsCheckInitialFetched) {
                    isInitialFetched = checkIsInitialFetched({
                        selectorsCheckInitialFetched: selectorsCheckInitialFetched,
                        store: store,
                    });
                    if (isInitialFetched) {
                        return [2 /*return*/];
                    }
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 24, 38, 43]);
                if (!resetAction) return [3 /*break*/, 3];
                return [4 /*yield*/, put(resetAction())];
            case 2:
                _b.sent();
                return [3 /*break*/, 5];
            case 3:
                if (!resetActionsArray) return [3 /*break*/, 5];
                return [4 /*yield*/, all(resetActionsArray.map(function (action) { return put(action()); }))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5:
                if (!loadingStartAction) return [3 /*break*/, 7];
                return [4 /*yield*/, put(loadingStartAction())];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7:
                formattedRequestParams_1 = requestDataFormatter
                    ? requestDataFormatter(requestOptions)
                    : requestOptions;
                if (!requestErrorHandlerProcessParams) return [3 /*break*/, 9];
                return [5 /*yield**/, __values(requestErrorHandlerProcess(__assign(__assign({}, requestErrorHandlerProcessParams), { request: function () {
                            return request(__assign(__assign({}, formattedRequestParams_1), { isErrorTextStraightToOutput: withoutFormattingError }));
                        } })))];
            case 8:
                responseData = _b.sent();
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, call(request, __assign(__assign({}, formattedRequestParams_1), { isErrorTextStraightToOutput: withoutFormattingError }))];
            case 10:
                // make the request with language dictionary (optionally with params)
                // TODO FIX
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                responseData = _b.sent();
                _b.label = 11;
            case 11:
                // if an error in request
                if (responseData.error) {
                    // eslint-disable-next-line
                    throw {
                        requestParams: formattedRequestParams_1,
                        message: responseData.errorText,
                        additionalErrors: responseData.additionalErrors,
                    };
                }
                formattedResponseData = responseDataFormatter
                    ? responseDataFormatter(responseData.data)
                    : responseData.data;
                filteredResponseData_1 = isBatchRequest
                    ? filterBatchedResponseData(responseData)
                    : formattedResponseData;
                if (!(actionSuccess && filteredResponseData_1)) return [3 /*break*/, 13];
                return [4 /*yield*/, put(actionSuccess(filteredResponseData_1))];
            case 12:
                _b.sent();
                return [3 /*break*/, 15];
            case 13:
                if (!actionsArraySuccess) return [3 /*break*/, 15];
                return [4 /*yield*/, all(actionsArraySuccess.map(function (action) { return put(action(filteredResponseData_1)); }))];
            case 14:
                _b.sent();
                _b.label = 15;
            case 15:
                if (!requestExtraDataHandlerOptions) return [3 /*break*/, 17];
                return [4 /*yield*/, put(requestExtraDataHandlerActionSaga({
                        data: filteredResponseData_1,
                        options: requestExtraDataHandlerOptions,
                        errorLogger: errorLogger,
                    }))];
            case 16:
                _b.sent();
                _b.label = 17;
            case 17:
                if (!(showSuccessNotification &&
                    (textMessageSuccess || titleMessageSuccess) &&
                    setModalAction)) return [3 /*break*/, 19];
                return [4 /*yield*/, put(setModalAction({
                        status: 'success',
                        title: titleMessageSuccess,
                        text: textMessageSuccess,
                    }))];
            case 18:
                _b.sent();
                _b.label = 19;
            case 19:
                if (!callBackOnSuccess) return [3 /*break*/, 21];
                return [4 /*yield*/, callBackOnSuccess({
                        dispatch: dispatch,
                        responseData: filteredResponseData_1,
                        store: store,
                    })];
            case 20:
                _b.sent();
                _b.label = 21;
            case 21:
                if (!redirectRouteParamsSuccess) return [3 /*break*/, 23];
                redirectData = formatDataToRedirectParamsSuccess
                    ? formatDataToRedirectParamsSuccess(__assign(__assign({}, redirectRouteParamsSuccess), filteredResponseData_1))
                    : redirectRouteParamsSuccess;
                return [4 /*yield*/, put(redirectManagerSagaAction(redirectData))];
            case 22:
                _b.sent();
                _b.label = 23;
            case 23: return [3 /*break*/, 43];
            case 24:
                error_1 = _b.sent();
                isAbortError = getIsAbortRequestError(error_1.message);
                if (!!isAbortError) return [3 /*break*/, 37];
                console.error("error in initLoadManagerWorkerSaga at section ".concat(counterRequests), error_1.message);
                if (!isDataCritical) return [3 /*break*/, 27];
                if (!setAppErrorAction) return [3 /*break*/, 26];
                console.error('get the critical fetch fail');
                if (eventNameToCancelRequests && !isNode) {
                    event_1 = new CustomEvent(eventNameToCancelRequests, {
                        detail: { id: requestsSectionId },
                    });
                    document.dispatchEvent(event_1);
                }
                return [4 /*yield*/, put(setAppErrorAction())];
            case 25:
                _b.sent();
                return [3 /*break*/, 27];
            case 26:
                // eslint-disable-next-line
                console.warn('isDataCritical flag was provided and activated but there is no setAppErrorAction to throw');
                _b.label = 27;
            case 27:
                if (!errorAction) return [3 /*break*/, 29];
                return [4 /*yield*/, put(errorAction(error_1.message))];
            case 28:
                _b.sent();
                return [3 /*break*/, 31];
            case 29:
                if (!errorActionsArray) return [3 /*break*/, 31];
                return [4 /*yield*/, all(errorActionsArray.map(function (action) { return put(action(error_1.message)); }))];
            case 30:
                _b.sent();
                _b.label = 31;
            case 31:
                if (!callBackOnError) return [3 /*break*/, 33];
                return [4 /*yield*/, callBackOnError({ dispatch: dispatch, store: store, error: error_1 })];
            case 32:
                _b.sent();
                _b.label = 33;
            case 33:
                if (!(showErrorNotification && setModalAction)) return [3 /*break*/, 35];
                customModalTitle = titleMessageError || (getErrorModalActionTitle === null || getErrorModalActionTitle === void 0 ? void 0 : getErrorModalActionTitle(error_1.message));
                params = customModalTitle
                    ? {
                        status: 'error',
                        title: customModalTitle,
                        text: error_1.message,
                    }
                    : {
                        status: 'error',
                        title: error_1.message,
                    };
                return [4 /*yield*/, put(setModalAction(params))];
            case 34:
                _b.sent();
                _b.label = 35;
            case 35:
                if (errorLogger && !disableErrorLogger) {
                    errorLogger({
                        error: error_1,
                        message: "[initLoadManagerWorkerSaga]: get an error at section ".concat(counterRequests),
                    });
                }
                if (!redirectRouteParamsError) return [3 /*break*/, 37];
                redirectData = formatDataToRedirectParamsError
                    ? formatDataToRedirectParamsError(__assign(__assign({}, redirectRouteParamsError), error_1.additionalErrors))
                    : redirectRouteParamsError;
                return [4 /*yield*/, put(redirectManagerSagaAction(redirectData))];
            case 36:
                _b.sent();
                _b.label = 37;
            case 37: return [3 /*break*/, 43];
            case 38:
                if (!isNode) {
                    document.dispatchEvent(new CustomEvent(eventToCatchEndedProcesses, {
                        detail: { id: requestsSectionId },
                    }));
                }
                if (!loadingStopAction) return [3 /*break*/, 40];
                return [4 /*yield*/, put(loadingStopAction())];
            case 39:
                _b.sent();
                _b.label = 40;
            case 40:
                if (!initialLoadingFinishAction) return [3 /*break*/, 42];
                return [4 /*yield*/, put(initialLoadingFinishAction())];
            case 41:
                _b.sent();
                _b.label = 42;
            case 42: return [7 /*endfinally*/];
            case 43: return [2 /*return*/];
        }
    });
}
